// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_OverviewCharts_chartsContainer__P0Xa1 {
  display: flex;
  flex-wrap: wrap;
  margin: 16px -8px 0;
}

.storage_OverviewCharts_bigChartItem__SAat9 {
  width: 66.666%;
  min-width: 500px;
  box-sizing: border-box;
  flex-grow: 1;
  padding: 0 8px;
  margin-bottom: 16px;
}

.storage_OverviewCharts_smallChartItem__GK4X3 {
  width: 33.333%;
  min-width: 300px;
  box-sizing: border-box;
  flex-grow: 1;
  padding: 0 8px;
  margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/OverviewCharts/OverviewCharts.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".chartsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 16px -8px 0;\n}\n\n.bigChartItem {\n  width: 66.666%;\n  min-width: 500px;\n  box-sizing: border-box;\n  flex-grow: 1;\n  padding: 0 8px;\n  margin-bottom: 16px;\n}\n\n.smallChartItem {\n  width: 33.333%;\n  min-width: 300px;\n  box-sizing: border-box;\n  flex-grow: 1;\n  padding: 0 8px;\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartsContainer": `storage_OverviewCharts_chartsContainer__P0Xa1`,
	"bigChartItem": `storage_OverviewCharts_bigChartItem__SAat9`,
	"smallChartItem": `storage_OverviewCharts_smallChartItem__GK4X3`
};
export default ___CSS_LOADER_EXPORT___;
